export default __webpack_public_path__ + "static/media/12_86gI_q3g-min.10ef6ab2.jpeg";